const locale = {
	pageTitle: 'ISO 9001 Quality Management Certification | QingYi Precision',
	pageDesc:
		'QingYi Precision holds ISO 9001:2015 certification, operating under a standardized production process with full quality traceability. Every batch undergoes CMM measurement and visual inspection before shipment to meet customer specifications and international quality standards.',
	pageKeywords:
		'ISO 9001, ISO 9001:2015, quality management system, quality certification, CMM measurement, precision machining QC, QingYi Precision',
	title: 'ISO 9001 Quality Management Certification',
	subtitle: 'ISO 9001:2015 品質管理系統驗證',
	clickHint: 'Click the image to enlarge'
};

export default locale;
